import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

document.addEventListener('DOMContentLoaded', function () {
  const mobileMenuButton = document.querySelector('.hamburger-btn');
  const navMenu = document.querySelector('.header__nav');
  let menuIsOpen = false;
  let width = window.innerWidth;

  // Helper function to check if we're in mobile/tablet mode
  const isMobileView = () => window.matchMedia('(max-width: 1024px)').matches;

  // Store dropdown instances for cross-reference (declare early so it's accessible)
  const dropdownInstances = new Map();

  // Function to close all dropdowns
  const closeAllDropdowns = () => {
    dropdownInstances.forEach((instance) => {
      if (instance.isOpen()) {
        instance.deactivateDropdown();
      }
    });
  };

  window.addEventListener('resize', () => {
    if (window.innerWidth != width) {
      navMenu?.removeAttribute('style');
    }

    width = window.innerWidth;
  });

  const mTl = gsap.timeline({
    paused: true,
    yoyo: true,
    onStart: function () {
      menuIsOpen = true;
    },
    onReverseComplete: function () {
      menuIsOpen = false;
      // Close all dropdowns when mobile menu closes
      if (isMobileView()) {
        closeAllDropdowns();
      }
    },
  });

  mTl.set(navMenu, {
    display: 'flex',
    height: 0,
  });

  mTl.to(navMenu, {
    autoAlpha: 1,
    duration: 0.5,
    height: 'auto',
    ease: 'power2.out',
  });

  // animate all link elements
  const links = navMenu?.querySelectorAll('.top-link');
  console.log('links', links);
  // If this is a mobile device, and a phone or tablet, then we want to animate the links
  if (isMobileView()) {
    // Set initial state for better control
    gsap.set(links ?? [], {
      autoAlpha: 0,
      y: 60,
      scale: 0.95,
    });

    mTl.to(
      links ?? [],
      {
        duration: 0.6, // Slightly shorter duration
        y: 0,
        autoAlpha: 1,
        scale: 1,
        stagger: 0.06, // Slightly longer stagger for more noticeable effect
        ease: 'power2.out',
        force3D: true, // Force hardware acceleration
      },
      '<+=0.2'
    );
  }

  const animateMenu = () => {
    mTl.timeScale(1);
    mTl.play();
  };

  const reverseMenu = () => {
    mTl.timeScale(3);
    mTl.reverse();
  };

  mobileMenuButton?.addEventListener('click', () => {
    mobileMenuButton.classList.toggle('active');
    console.log('Menu is open:', menuIsOpen);
    if (!menuIsOpen) {
      animateMenu();
    } else {
      reverseMenu();
    }
  });

  const dropdownContainers = document.querySelectorAll('.dropdown-container');

  // Initialize each dropdown
  dropdownContainers.forEach((container) => {
    const trigger = container.querySelector('.dropdown-trigger');
    const content = container.querySelector('.dropdown-content');
    const arrow = container.querySelector('.dropdown-arrow');
    let isOpen = false;

    // Create unique timeline for each dropdown
    let tl = gsap.timeline({
      paused: true,
      onStart() {
        isOpen = true;
      },
      onComplete() {
        if (isMobileView()) {
          trigger?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      },
      onReverseComplete() {
        isOpen = false;
      },
    });

    const playAnimation = () => {
      if (isOpen) return;
      tl.timeScale(1);
      tl.play();
    };

    const reverseAnimation = () => {
      tl.timeScale(6);
      tl.reverse();
    };

    // Function to close other dropdowns
    const closeOtherDropdowns = () => {
      dropdownInstances.forEach((instance, otherContainer) => {
        if (otherContainer !== container && instance.isOpen()) {
          otherContainer.classList.remove('dropdown-active');
          const otherArrow = otherContainer.querySelector('.dropdown-arrow');
          gsap.to(otherArrow, {
            duration: 0.2,
            rotation: 0,
            ease: 'power2.out',
          });
          instance.reverseAnimation();
        }
      });
    };

    // Function to activate this dropdown
    const activateDropdown = () => {
      closeOtherDropdowns();

      container.classList.add('dropdown-active');

      // Rotate arrow
      gsap.to(arrow, {
        duration: 0.2,
        rotation: 180,
        ease: 'power2.out',
      });

      // Play dropdown animation
      playAnimation();
    };

    // Function to deactivate this dropdown
    const deactivateDropdown = () => {
      container.classList.remove('dropdown-active');

      // Rotate arrow back
      gsap.to(arrow, {
        duration: 0.2,
        rotation: 0,
        ease: 'power2.out',
      });

      // Reverse dropdown animation
      reverseAnimation();
    };

    // Store instance for cross-reference
    dropdownInstances.set(container, {
      isOpen: () => isOpen,
      reverseAnimation,
      activateDropdown,
      deactivateDropdown,
    });

    // Trigger click handler - works on all devices (entire trigger element)
    trigger?.addEventListener('click', (e) => {
      if (isMobileView()) {
        e.preventDefault();
      }

      if (isOpen) {
        deactivateDropdown();
      } else {
        activateDropdown();
      }
    });

    // Set initial state
    gsap.set(content, {
      opacity: 0,
      height: 0,
      autoAlpha: 0,
      y: 60,
      scale: 0.95,
    });

    // Animation timeline
    tl.to(content, {
      height: 'auto',
      autoAlpha: 1,
      duration: 0.6,
      ease: 'power2.out',
      opacity: 1,
      y: 0,
      scale: 1,
    });

    const innerElems = content?.querySelectorAll('*');

    tl.from(
      innerElems ?? [],
      {
        duration: 1,
        y: 60,
        opacity: 0,
        stagger: 0.01,
        ease: 'power2.out',
      },
      '-=0.5'
    );

    const links = content?.querySelectorAll('.dropdown__links a') ?? [];

    links?.forEach((link) => {
      const split = new SplitText(link, { type: 'chars, words' });
      const tl = gsap.timeline({
        paused: true,
        yoyo: true,
      });

      tl.to(split.words, {
        duration: 0.3,
        stagger: 0.1,
        color: 'var(--color-teal)',
      });

      link.addEventListener('mouseenter', () => {
        if (!isMobileView()) tl.play();
      });

      link.addEventListener('mouseleave', () => {
        if (!isMobileView()) tl.reverse();
      });
    });

    let hoverTimeout: NodeJS.Timeout;

    // Only add hover events on desktop (above 1024px)
    if (!isMobileView()) {
      // Mouse enter
      container.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimeout);
        activateDropdown();
      });

      // Mouse leave
      container.addEventListener('mouseleave', function () {
        hoverTimeout = setTimeout(() => {
          deactivateDropdown();
        }, 100);
      });
    }
  });
});
